/// <reference path="irep.js"/>

IREP.SWICTeaser = (function () {

	var init = function () {
		var bgVideo = document.getElementById("backgroundVideo");
		bgVideo.loop = true;

		var viewport = document.querySelector("meta[name=viewport]");
		viewport.setAttribute('content', 'width=1280');

		var sndDoorOpen = document.getElementById("sndDoorOpen");

		//$("#SWIC").css("height", $(document).height()).css("width",$(document).width());
		$("body").css("height", "100%");
		$("form").css("height", "100%");
		$("html").css("height", "100%");
		$("nav").css("display", "none");
		$("#contentContainer").css("height", "100%");

		$("#mainDoor").on("click", function () {
			sndDoorOpen.play();
			$("#mainDoor").animate({ width: "1260px", height: "710px" }, 1500);
			$("#mainDoorShadow").fadeIn(1500, function () {
				$("#mainDoor").animate({ top: "-1280px" }, 3000, function () {
					sndDoorOpen.pause();
				});
				bgVideo.play();
			});
		});

		$(".txtCode").on("focus", function () { $(this).val(""); });

		$(".txtCode").on("keyup", function () {
			if ($(this).val().length > 0) {
				processCode(this.id);
			}
		});
	};

	var processCode = function (id) {
		var code = $("#txt1").val() + $("#txt2").val() + $("#txt3").val() + $("#txt4").val() + $("#txt5").val() + $("#txt6").val();

		if (code.toUpperCase() == "LIEBER") {
		    $("#SWIC").fadeOut(500, function () { $("#downloads").fadeIn(500); $("nav").fadeIn(500);});
		} else {
			switch (id) {
				case "txt1":
					$("#txt2").focus();
					break;
				case "txt2":
					$("#txt3").focus();
					break;
				case "txt3":
					$("#txt4").focus();
					break;
				case "txt4":
					$("#txt5").focus();
					break;
				case "txt5":
					$("#txt6").focus();
					break
				default:
					break;
			}
		}
	}

	var playTeaser = function () {
		$("#screenOverlay").show();
		$("#codeBar").animate({ top: "460px" }, 1000);

		$("#mainVideo").css("visibility", "visible");
		var mainVideo = document.getElementById("mainVideo");
		mainVideo.play();
		$("#backgroundVideo").animate({ volume: 0 }, 4000);

		mainVideo.onended = function (e) {
			$("#backgroundVideo").animate({ volume: 1.0 }, 2000);
			$("#mainVideo").fadeOut(500);
		}
	}

	return {
		init: init
	};
})();


IREP.SWICEarlyReg = (function () {

    var init = function () {
        IREP.callApi("SWIC/isswicregistered", "GET").done(function (data) {
            if (data.registered) {
                $("#divSchoolNominations").show();
            } else {
                $("#divManagerRegistration").show();
            }
        });

        $("#submitManager").on("click", function () { submitManagerInfo() });
        $("#submitSchoolNomination").on("click", function () { NominateSchool() });
        GetNominatedSchools();
    };

    function submitManagerInfo() {
        var valid = false;

        if ($("#manager").prop("checked")) {
            valid = true;
        } else if ($("#authorized").prop("checked")) {
            if ($("#txtMgrName").val().length == 0) {
                $("#txtMgrName").addClass("required");
            } else {
                $("#txtMgrName").removeClass("required");
                valid = true;
            }

            if(valid){
                if ($("#txtMgrEmail").val().length == 0) {
                    $("#txtMgrEmail").addClass("required");
                    valid = false;
                } else {
                    $("#txtMgrEmail").removeClass("required");
                    valid = true;
                }
            }
        }

        if (valid) {
            var params = { isManager: true, managerName: $("#txtMgrName").val(), managerEmail: $("#txtMgrEmail").val() };
            IREP.callApi("SWIC/registermanagerinfo", "POST", params).done(function () {
            });
            $("#divManagerRegistration").fadeOut(250, function () { $("#divSchoolNominations").fadeIn(250) })
        }
    }

    function NominateSchool() {
        var valid = false;

        if ($("#txtSchoolName").val().length == 0) {
            $("#txtSchoolName").addClass("required");
        } else {
            $("#txtSchoolName").removeClass("required");
            valid = true;
        }

        if (valid) {
            if ($("#txtSchoolCity").val().length == 0) {
                $("#txtSchoolCity").addClass("required");
                valid = false;
            } else {
                $("#txtSchoolCity").removeClass("required");
                valid = true;
            }

            if (valid) {
                if ($("#txtSchoolState").val().length == 0) {
                    $("#txtSchoolState").addClass("required");
                    valid = false;
                } else {
                    $("#txtSchoolState").removeClass("required");
                    valid = true;
                }
            }
        }

        if (valid){
            var params = { schoolName: $("#txtSchoolName").val(), city: $("#txtSchoolCity").val(), state: $("#txtSchoolState").val() };
            IREP.callApi("SWIC/insertschool", "POST", params).done(function (data) {
                $("#txtSchoolName").val("");
                $("#txtSchoolCity").val("");
                $("#txtSchoolState").val("");
                GetNominatedSchools();
            });
        }
    }

    function GetNominatedSchools() {
        IREP.callApi("SWIC/nominatedschools", "GET").done(function (data) {
            ProcessSchoolData(data);
        });
    }

    function ProcessSchoolData(data) {

        var x = 0;
        $("#nominatedSchoolList").html("");

        while (x <= data.schools.length-1) {
            $("#nominatedSchoolList").html($("#nominatedSchoolList").html() + "<div>" + data.schools[x].school + " / " + data.schools[x].city + ", " + data.schools[x].state + "</div>");
            x++;
        }

        if (data.schools.length > 0) {
            $("#nominatedSchools").show();

            if (data.schools.length > 4) {
                $("#nominationForm").hide();
            }
        }
    }

    return {
        init: init
    };
})();

IREP.SWICToken = (function () {

    var init = function () {
        $("#redeemToken").on("click", function () { redeemToken();});
    };

    var redeemToken = function () {
        var params = { PaxUID: IREP.options.user.currentUID };
        IREP.callApi("SWIC/RedeemToken", "GET", params).done(function (data) {
            ProcessTokenData(data);
        });
    };


    function ProcessTokenData(data) {
        var drawingEntries = 0;
        var availableTokens = 0;
        var randomEntries = 0;

        var info = data.info;
        if (info != null) {
            availableTokens = info.availableTokens;
            drawingEntries = info.drawingEntries;
            randomEntries = info.randomEntries;

            $("#drawingEntries").html('+' + randomEntries.toString());
            setTimeout(function () { $("#drawingEntries").html(pad(drawingEntries, 5)) }, 2000);
            $("#currentAvailableTokens").html(availableTokens);

            if (availableTokens > 0) {
                $("#redeemToken").fadeIn(500);
            } else {
                $("#redeemToken").hide();
            }
        }
    }

    function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    return {
        init: init
    };
})();

IREP.SchoolVoting = (function () {
    var init = function () {
        $(".vote").on("click", function () {
            $(this).data("votes", $(this).data("votes") + 1);

            var params = { schoolId: $(this).data("school") };
            IREP.callApi("SWIC/schoolvote", "POST", params).done(function () {
            });

            $(".vote").html(function () { return "Votes: " + $(this).data("votes").toString() });
            $(".vote").addClass("votes");
            $(".votes").removeClass("vote");
        })
    };
    
    return {
        init: init
    };
})();
IREP.SWICExtReg = (function () {

    var init = function () {

        $("#divManagerRegistration").show();
        $("#submitManager").on("click", function () { submitManagerInfo() });
        $("#submitSchoolNomination").on("click", function () { NominateSchool() });
        //GetNominatedSchools();
    };

    function submitManagerInfo() {
        var valid = false;

        if ($("#manager").prop("checked")) {
            if ($("#txtMyName").val().length == 0) {
                $("#txtMyName").addClass("required");
            } else {
                $("#txtMyName").removeClass("required");
                valid = true;
            }

            if (valid) {
                if ($("#txtMyEmail").val().length == 0) {
                    $("#txtMyEmail").addClass("required");
                    valid = false;
                } else {
                    $("#txtMyEmail").removeClass("required");
                    valid = true;
                }
            }

            if (valid) {
                if ($("#ddlStoreChain").val() == 0) {
                    $("#ddlStoreChain").addClass("required");
                    valid = false;
                } else {
                    $("#ddlStoreChain").removeClass("required");
                    valid = true;
                }
            }

            if (valid) {
                if ($("#ddlStores").val() == 0) {
                    $("#ddlStores").addClass("required");
                    valid = false;
                } else {
                    $("#ddlStores").removeClass("required");
                    valid = true;
                }
            }

        } else if ($("#authorized").prop("checked")) {
            if ($("#txtMyName").val().length == 0) {
                $("#txtMyName").addClass("required");
            } else {
                $("#txtMyName").removeClass("required");
                valid = true;
            }

            if (valid) {
                if ($("#txtMyEmail").val().length == 0) {
                    $("#txtMyEmail").addClass("required");
                    valid = false;
                } else {
                    $("#txtMyEmail").removeClass("required");
                    valid = true;
                }
            }
            
            if (valid) {
                if ($("#txtMgrName").val().length == 0) {
                    $("#txtMgrName").addClass("required");
                } else {
                    $("#txtMgrName").removeClass("required");
                    valid = true;
                }
            }
            
            if (valid) {
                if ($("#txtMgrEmail").val().length == 0) {
                    $("#txtMgrEmail").addClass("required");
                    valid = false;
                } else {
                    $("#txtMgrEmail").removeClass("required");
                    valid = true;
                }
            }

            if (valid) {
                if ($("#ddlStoreChain").val() == 0) {
                    $("#ddlStoreChain").addClass("required");
                    valid = false;
                } else {
                    $("#ddlStoreChain").removeClass("required");
                    valid = true;
                }
            }

            if (valid) {
                if ($("#ddlStores").val() == 0) {
                    $("#ddlStores").addClass("required");
                    valid = false;
                } else {
                    $("#ddlStores").removeClass("required");
                    valid = true;
                }
            }
        }

        if (valid) {
            var params = { registrantsName: $("#txtMyName").val(), registrantsEmail: $("#txtMyEmail").val(), storeId: $("#ddlStores").val(), isManager: true, managerName: $("#txtMgrName").val(), managerEmail: $("#txtMgrEmail").val() };
            IREP.callApi("SWIC/registerexternalmanagerinfo", "POST", params).done(function () {
            });
            $("#divManagerRegistration").fadeOut(250, function () { $("#divSchoolNominations").fadeIn(250) })

            GetNominatedSchools();
        }
    }

    function NominateSchool() {
        var valid = false;

        if ($("#txtSchoolName").val().length == 0) {
            $("#txtSchoolName").addClass("required");
        } else {
            $("#txtSchoolName").removeClass("required");
            valid = true;
        }

        if (valid) {
            if ($("#txtSchoolCity").val().length == 0) {
                $("#txtSchoolCity").addClass("required");
                valid = false;
            } else {
                $("#txtSchoolCity").removeClass("required");
                valid = true;
            }

            if (valid) {
                if ($("#txtSchoolState").val().length == 0) {
                    $("#txtSchoolState").addClass("required");
                    valid = false;
                } else {
                    $("#txtSchoolState").removeClass("required");
                    valid = true;
                }
            }
        }

        if (valid) {
            var params = { storeId: $("#ddlStores").val(), schoolName: $("#txtSchoolName").val(), city: $("#txtSchoolCity").val(), state: $("#txtSchoolState").val() };
            IREP.callApi("SWIC/insertschoolexternal", "POST", params).done(function (data) {
                $("#txtSchoolName").val("");
                $("#txtSchoolCity").val("");
                $("#txtSchoolState").val("");
                GetNominatedSchools();
            });
        }
    }

    function GetNominatedSchools() {
        var params = { storeId: $("#ddlStores").val()};
        IREP.callApi("SWIC/externalnominatedschools", "GET", params).done(function (data) {
            ProcessSchoolData(data);
        });
    }

    function ProcessSchoolData(data) {

        var x = 0;
        $("#nominatedSchoolList").html("");

        while (x <= data.schools.length - 1) {
            $("#nominatedSchoolList").html($("#nominatedSchoolList").html() + "<div>" + data.schools[x].school + " / " + data.schools[x].city + ", " + data.schools[x].state + "</div>");
            x++;
        }

        if (data.schools.length > 0) {
            $("#nominatedSchools").show();

            if (data.schools.length > 4) {
                $("#nominationForm").hide();
            }
        }
    }

    return {
        init: init
    };
})();


IREP.SWICTransmission = (function () {

    var init = function () {
        $("#SWIC5Main").css("background", "rgba(0,0,0,0)");
        //var bgVideo = document.getElementById("backgroundVideo");
        //bgVideo.loop = true;

        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=1280');

        var preRegDoc = document.getElementById("preRegDoc");
        var sndDoorOpen = document.getElementById("sndDoorOpen");
        $("#screenOverlay").show();
        
        
        $("body").css("height", "100%");
        $("form").css("height", "100%");
        $("html").css("height", "100%");
        $("#contentContainer").css("height", "100%");
        $("#doc").on("click", function () {
            preRegDoc.play();
        })
        $("#mainDoor").on("click", function () {
            sndDoorOpen.play();
            $("#mainDoor").animate({ width: "1260px", height: "710px" }, 1500);
            $("#mainDoorShadow").fadeIn(1500, function () {
                $("#mainDoor").animate({ top: "-1280px" }, 3000, function () {
                    sndDoorOpen.pause();
                });
                //bgVideo.play();
            });
        });

        $("#light1").on("click", function () {
            playVideo1();
        });

        $("#light2").on("click", function () {
            playVideo2();
        });

        $("#light3").on("click", function () {
            playVideo3();
        });

        $("#light4").on("click", function () {
            playVideo4();
        });

        $("#light5").on("click", function () {
            playVideo5();
        });
        $("#light6").on("click", function () {
            playVideo6();
        });
        $("#light7").on("click", function () {
            playVideo7();
        });
        $("#light8").on("click", function () {
            playVideo8();
        });
        $("#light9").on("click", function () {
            playVideo9();
        });
        $("#light10").on("click", function () {
            playVideo10();
        });
        $("#light11").on("click", function () {
            playVideo11();
        });
        $("#light12").on("click", function () {
            playVideo12();
        });
    };


    var playVideo1 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");

        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/video/asmo/Seg1_OpeningScene.mp4";

        mainVideo.load();
        mainVideo.play();

        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo2 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/video/asmo/Seg2_Trigate.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo3 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/ComibBook_Vol1_Animation_no_TV_Final.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo4 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg3noTV_1.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo5 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg4noTV_1.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo6 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/ComicBook_Vol2_Animation_no_TV_Final.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo7 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg5noTV.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo8 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg6noTV.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo9 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/ComicBook_Vol3_Animation_no_TV_Final.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo10 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg7noTV.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo11 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/ComicbookVol4AnimationNoTvFinal.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    var playVideo12 = function () {
        $("#screenOverlay").show();
        $("#message").hide();

        $("#mainVideo").css("visibility", "visible");
        $("#mainVideo").show();
        var mainVideo = document.getElementById("mainVideo");


        var mp4 = document.getElementById('mp4');
        mp4.src = "/Content/Images/ASMO/2014SWIC/Video/GreatPowerStruggleSeg8noTV.mp4";

        mainVideo.load();
        mainVideo.play();


        mainVideo.onended = function (e) {
            $("#mainVideo").fadeOut(500);
            $("#message").fadeIn(500);
        }
    }

    return {
        init: init
    };
})();

IREP.SWICTimeline = (function () {
    var init = function () {
        $('map area, .fake').on('click', function () {
            var screen = $(this).data('screen');
            
            $('#timeline .screen > div').hide();
            $('#timeline .screen').find('.' + screen).show();

            return false;
        })
    };

    return {
        init: init
    };
}());